var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { height: "100%" } }, [
    _vm.loading
      ? _c("div", [_c("loading", { attrs: { show: _vm.loading } })], 1)
      : _c("div", { staticStyle: { position: "relative", height: "100%" } }, [
          !_vm.valid
            ? _c("div", {}, [
                _c(
                  "div",
                  {
                    staticClass: "font-20",
                    staticStyle: {
                      position: "fixed",
                      top: "50%",
                      left: "50%",
                      color: "#000",
                      transform: "translate(-50%, -50%)"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("InvalidData")))]
                )
              ])
            : _c(
                "div",
                { staticStyle: { height: "100%" } },
                [
                  _c(
                    "swiper",
                    {
                      ref: "postureSwiper",
                      attrs: { options: _vm.swiperOption }
                    },
                    [
                      _c(
                        "swiper-slide",
                        { staticClass: "cover" },
                        [
                          _c("posture_home", {
                            attrs: { coverInfo: _vm.coverInfo },
                            on: {
                              slideIn: function($event) {
                                _vm.slideIn(1)
                              },
                              changeLang: _vm.changeLang
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "swiper-slide",
                        { staticClass: "pagintaion-space" },
                        [
                          _c(
                            "swiper",
                            {
                              ref: "viewsSwiper",
                              attrs: { options: _vm.swiperOptionview }
                            },
                            [
                              _c("div", {
                                staticClass:
                                  "swiper-pagination postureView-swiper-pagination content-row content-row-view",
                                attrs: { slot: "pagination" },
                                slot: "pagination"
                              }),
                              _vm._v(" "),
                              _c(
                                "swiper-slide",
                                [
                                  _c("Posture_front", {
                                    attrs: {
                                      points: _vm.points,
                                      photos: _vm.photos,
                                      severeRisks: _vm.severeRisks,
                                      mildRisks: _vm.mildRisks,
                                      normalRisks: _vm.normalRisks
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "swiper-slide",
                                [
                                  _c("Posture_flank", {
                                    attrs: {
                                      points: _vm.points,
                                      photos: _vm.photos,
                                      severeRisks: _vm.severeRisks,
                                      mildRisks: _vm.mildRisks,
                                      normalRisks: _vm.normalRisks
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "swiper-slide",
                        { staticStyle: { overflow: "scroll !important" } },
                        [
                          _c("Posture_symp", {
                            attrs: {
                              severeRisks: _vm.severeRisks,
                              mildRisks: _vm.mildRisks,
                              normalRisks: _vm.normalRisks
                            },
                            on: {
                              setModalInfo: _vm.setModalInfo,
                              share: _vm.share,
                              getSolutions: _vm.getSolutions
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.MuscleShow == true
                        ? _c(
                            "swiper-slide",
                            {
                              staticClass: "pagintaion-space",
                              staticStyle: { background: "#e9e9e9" }
                            },
                            [
                              _c("Posture_report", {
                                ref: "Posture_bone",
                                attrs: { updateSwiper: _vm.updateSwiper },
                                on: {
                                  slideIn: _vm.slideIn,
                                  updateSwiper: _vm.updateSwiperIndex
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", {
                        staticClass:
                          "swiper-pagination posture-swiper-pagination content-row content-row-around",
                        attrs: { slot: "pagination" },
                        slot: "pagination"
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.modalInfo
                    ? _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.touchJump == false,
                              expression: "touchJump==false"
                            }
                          ],
                          staticClass: "posture-modal"
                        },
                        [
                          _c(
                            "b-modal",
                            {
                              ref: "riskModalRef",
                              attrs: {
                                size: "lg",
                                title: "Large Modal",
                                "hide-footer": "",
                                "hide-header": ""
                              },
                              on: { shown: _vm.initRiskBar }
                            },
                            [
                              _c("Posture_modal", {
                                attrs: {
                                  modalInfo: _vm.modalInfo,
                                  isUpdate: _vm.isUpdate
                                },
                                on: { hideModal: _vm.hideModal }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
        ]),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showMini,
            expression: "showMini"
          }
        ]
      },
      [
        _c("div", {
          staticClass: "share-wechat-mini",
          attrs: { id: "shareWechatMini" },
          on: {
            click: function($event) {
              _vm.shareWechatMini()
            }
          }
        })
      ]
    ),
    _vm._v(" "),
    _c("div", {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isWechat == true,
          expression: "isWechat==true"
        }
      ],
      attrs: { id: "jumpMiniUrl" },
      on: {
        click: function($event) {
          _vm.getSolutions()
        }
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-480276c8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-480276c8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Posture.vue
// module id = null
// module chunks = 